export const unavailable = 'Xiii, já foi tudo :(';
export const inCash = `no Pix`;
export const discount = `% de desconto no pix`;
export const withInterest = 'com juros';